import * as React from 'react';
import MerchantCategory from '../../../../domain/entities/MerchantCategory';
import css from './ExploreCategoryCard.module.scss';

interface Props {
  category: MerchantCategory;
}

class ExploreCategoryCard extends React.PureComponent<Props> {
  public static defaultProps: Props = {
    category: {
      id: 0,
      nameJA: '',
      nameEN: '',
      nameKO: '',
      displayOrder: 0,
      imageUrl: '',
    },
  };

  public render() {
    return (
      <div className={css.ExploreCategoryCard}>
        <a href={`/categories/${this.props.category.id}`}>
          <div
            className={css.ExploreCategoryCard__Background}
            style={{ backgroundImage: `url(${this.props.category.imageUrl})` }}
          >
            <div className={css.ExploreCategoryCard__Body}>
              <div className={css.ExploreCategoryCard__Heading}>
                {this.props.category.nameJA}
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default ExploreCategoryCard;
